import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

const MapViewModal = (props) => {
    const { branch, visible, closeModal } = props;

    return (
        <>
            <Modal
                size="lg"
                className='branch-map-modal'
                show={visible}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                // dialogClassName="modal-90w"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className='branch-title' title={branch.name}>{branch.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe title={branch.title} className='map-iframe' src={branch.mapUrl} frameBorder="0"></iframe>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MapViewModal